import { TableMap } from '../table-map';
import { addColumn } from './add-column';
import { cloneTr } from './clone-tr';
import { findTable } from './find';

// Returns a new transaction that adds a new column at index `columnIndex`.
export var addColumnAt = function addColumnAt(columnIndex) {
  return function (tr) {
    var table = findTable(tr.selection);
    if (table) {
      var map = TableMap.get(table.node);
      if (columnIndex >= 0 && columnIndex <= map.width) {
        return cloneTr(addColumn(tr, {
          map: map,
          tableStart: table.start,
          table: table.node
        }, columnIndex));
      }
    }
    return tr;
  };
};